export function createDeferred<T>() {
  if (typeof Promise.withResolvers === 'function') {
    return Promise.withResolvers<T>()
  }

  let reject: (reason?: unknown) => void = () => {}
  let resolve: (value: T | PromiseLike<T>) => void = () => {}
  // oxlint-disable-next-line promise/avoid-new -- Polyfill path for runtimes without Promise.withResolvers.
  const promise = new Promise<T>((promiseResolve, promiseReject) => {
    resolve = promiseResolve
    reject = promiseReject
  })

  return {
    promise,
    reject,
    resolve,
  }
}
